// extracted by mini-css-extract-plugin
export default {"wrapper":"FooterCellWrapper_wrapper__6J3df"};